import { render } from "./CarouselCelebration.vue?vue&type=template&id=164b0f42"
import script from "./CarouselCelebration.vue?vue&type=script&lang=js"
export * from "./CarouselCelebration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/CarouselCelebration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "164b0f42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('164b0f42', __exports__)) {
    api.reload('164b0f42', __exports__)
  }
  
  module.hot.accept("./CarouselCelebration.vue?vue&type=template&id=164b0f42", () => {
    api.rerender('164b0f42', render)
  })

}


export default __exports__